import { NotificationTemplateTypes } from '../base-types';

// eslint-disable-next-line import-x/prefer-default-export
export const notificationTemplatesSettingsTree = [
  {
    key: NotificationTemplateTypes.SECTION_MESSAGING,
    pages: [
      {
        key: NotificationTemplateTypes.MESSAGING_ALL_CHATS,
        actions: [
          {
            key: NotificationTemplateTypes.MESSAGING_UNASSIGNED_CHANNEL_NEW_MESSAGE_ACTION,
          },
          {
            key: NotificationTemplateTypes.MESSAGING_ASSIGNED_CHANNEL_NEW_MESSAGE_ACTION,
          },
          {
            key: NotificationTemplateTypes.MESSAGING_CHANNEL_ASSIGNED_ACTION,
          },
          {
            key: NotificationTemplateTypes.MESSAGING_CHANNEL_UNASSIGNED_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: NotificationTemplateTypes.SECTION_CUSTOMERS,
    pages: [
      {
        key: NotificationTemplateTypes.CUSTOMERS_APPLICATION,
        actions: [
          {
            key: NotificationTemplateTypes.CUSTOMERS_APPLICATION_ASSIGN_REVIEWER_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_APPLICATION_ALL_COF_PROCESSED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_APPLICATION_COF_DECLINED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_APPLICATION_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_COMMENT_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_COMMENT_WITH_REVIEWER_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_APPLICATION_READY_TO_REVIEW_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_APPLICATION_SUMSUB_VERIFICATION_STATUS_FAILED_ACTION,
          },
        ],
      },
      {
        key: NotificationTemplateTypes.INDIVIDUAL_CUSTOMERS,
        actions: [
          {
            key: NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_AGREEMENT_SIGNED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_BENEFICIARY_APPROVAL_REQUIRED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_CONTRACT_APPROVAL_REQUIRED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_DOCUMENT_COMMENT_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_ONGOING_MONITORING_MATCHES_FOUND_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_RISK_SCORE_UPDATED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_LOCK_MANUALLY_CREATED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_LOCK_AUTOMATICALLY_CREATED_ACTION,
          },
        ],
      },
      {
        key: NotificationTemplateTypes.CORPORATE_CUSTOMERS,
        actions: [
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_AGREEMENT_SIGNED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_DOCUMENT_EXPIRING_IN_14_DAYS_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_DOCUMENT_EXPIRING_IN_31_DAYS_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_HMRC_REGISTRATION_EXPIRING_IN_14_DAYS_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_BENEFICIARY_APPROVAL_REQUIRED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_CONTRACT_APPROVAL_REQUIRED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_COF_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_DOCUMENT_COMMENT_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_ONGOING_MONITORING_MATCHES_FOUND_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_RISK_SCORE_UPDATED_ACTION,
          },
          {
            key: NotificationTemplateTypes.CUSTOMERS_CORPORATE_HMRC_REGISTRATION_EXPIRING_IN_31_DAYS_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: NotificationTemplateTypes.SECTION_ISSUES,
    pages: [
      {
        key: NotificationTemplateTypes.ISSUES_ALL_ISSUES,
        actions: [
          {
            key: NotificationTemplateTypes.ISSUES_UPDATED_ALL_ACTION,
          },
          {
            key: NotificationTemplateTypes.ISSUES_UPDATED_ONLY_FOR_EXECUTOR_ACTION,
          },
          {
            key: NotificationTemplateTypes.ISSUES_UPDATED_ONLY_FOR_RESPONSIBLE_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: NotificationTemplateTypes.SECTION_TRANSACTIONS,
    pages: [
      {
        key: NotificationTemplateTypes.TRANSACTIONS_INCOMING,
        actions: [
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_NEW_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_NEW_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_AML_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_HELD_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_AML_INFO_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_REV_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_CHANGE_BY_FAILED_ACTION,
          },
        ],
      },
      {
        key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING,
        actions: [
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_NEW_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_NEW_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_NEW_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_AML_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_AML_INFO_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_REV_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_READY_TO_PSP_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_READY_TO_SEND_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_SENT_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_ARCH_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_CHANGE_BY_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_OUTGOING_CREATE_BY_INTEGRATION_FAILED_ACTION,
          },
        ],
      },
      {
        key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL,
        actions: [
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_NEW_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_NEW_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_NEW_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_AML_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_AML_INFO_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_REV_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_ARCH_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_CHANGE_BY_FAILED_ACTION,
          },
        ],
      },
      {
        key: NotificationTemplateTypes.TRANSACTIONS_EXCHANGE,
        actions: [
          {
            key: NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_FX_RATE_REQUEST_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_NEW_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_ARCH_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_CHANGE_BY_FAILED_ACTION,
          },
        ],
      },
      {
        key: NotificationTemplateTypes.TRANSACTIONS_NOSTRO,
        actions: [
          {
            key: NotificationTemplateTypes.TRANSACTIONS_NOSTRO_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_NOSTRO_STATUS_CHANGE_BY_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_NOSTRO_CREATE_BY_INTEGRATION_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_NOSTRO_STATUS_NEW_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_NOSTRO_STATUS_REV_ACTION,
          },
        ],
      },
      {
        key: NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION,
        actions: [
          {
            key: NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_AML_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_AML_DONE_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_ACCEPTED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            key: NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_CHANGE_BY_FAILED_ACTION,
          },
        ],
      },
    ],
  },
];
